<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'createTemplate',
})
</script>
<template>
    <a-modal title="电话拨号" :width="1000" :open="true" :maskClosable="false" :confirmLoading="state.loading" @ok="cancel"
        :footer="null" :zIndex="1100" @cancel="cancel">
        <a-spin :spinning="state.loading">
            <a-row :gutter="48" style="margin: 10px 0;">
                <a-col :span="6">连接状态</a-col>
                <a-col :span="6">摘挂机状</a-col>
                <a-col :span="6">录音状态</a-col>
                <a-col :span="6">答录状态</a-col>
            </a-row>
            <a-form ref="ruleForm" :model="formState" v-bind="formLayout" :rules="rules">
                <a-form-item label="公司名称">
                    {{ props.tableColumnsData?.full_name }}
                </a-form-item>
                <a-form-item label="电话号码">
                    {{ props.phone }}
                </a-form-item>
                <a-form-item label="拨号理由" name="remark" required="">
                    <a-textarea placeholder="请输入" v-model:value="formState.remark"></a-textarea>
                </a-form-item>
                <a-form-item label="本次拨号总结" name="remark" required="">
                    <a-textarea placeholder="请输入" v-model:value="formState.remark"></a-textarea>
                </a-form-item>
                <a-form-item label="操作">
                    <a-button type="primary" @click="onFormSubmit">立即拨号</a-button>
                </a-form-item>
            </a-form>
            功能开发中。。。
        </a-spin>
    </a-modal>
</template>

<script lang="ts" setup name="createTemplate">
import { reactive, ref, onMounted, computed } from 'vue'
import { message } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
const props = defineProps({
    tableColumnsData: {
        type: Object,
        default: () => null
    },
    phone: {
        type: String,
        default: ''
    }
})
const emit = defineEmits(['cancel', 'ok'])
const ruleForm = ref()
const rules = {}
const formLayout = {
    labelCol: {
        xs: { span: 7 },
        sm: { span: 7 }
    },
    wrapperCol: {
        xs: { span: 10 },
        sm: { span: 10 }
    }
}
interface state {
    loading: boolean
}
const state = reactive<state>({
    loading: false
})
interface formState {
    remark: string
}
let formState = reactive<formState>({
    remark: '',
})
onMounted(() => {
})
const cancel = () => {
    emit('cancel')
}
const onFormSubmit = () => {

}
</script>

<style lang="less" scoped></style>
